var _style, _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFire(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 72 72",
    style: {
      enableBackground: "new 0 0 72 72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#Rectangle-2_1_);}\r\n\t.st1{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Types_Fire",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -15)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle-2_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.6667,
    y1: 61.5333,
    x2: 10.6667,
    y2: 59.1333,
    gradientTransform: "matrix(30 0 0 -30 -284 1846)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FB9B51"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBAE46"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-2",
    className: "st0",
    d: "M36,0L36,0c19.9,0,36,16.1,36,36l0,0c0,19.9-16.1,36-36,36l0,0C16.1,72,0,55.9,0,36l0,0 C0,16.1,16.1,0,36,0z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    className: "st1",
    d: "M19.3,36.8c-3.3,0-6.5-1.4-8.8-3.8c-2.8-2.9-4-6.9-3.4-10.8c0.2-1.9,0.8-3.8,1.7-5.5 c-0.1,0.6-0.2,1.2-0.2,1.9c0,0.6,0.2,1.2,0.5,1.8c0,0,0,0,0-0.1c0.8-1.7,1.7-3.3,2.9-4.7c1.2-1.2,2.5-2.3,4-3.3 c0.9-0.6,1.7-1.2,2.4-1.9c2.8-3.2,1.1-9,1.1-9l0,0c0,0,0,0,0,0c1.9,1.8,3.3,4,4.1,6.5c0.2,1.5,0.2,3-0.1,4.4 c-0.2,1.6-0.4,2.9,0.2,3.6c0.4,0.3,0.8,0.5,1.3,0.5h0.2c0.6,0,1.2-0.3,1.6-0.8c0.9-1.6-1.1-5.1-1.1-5.2l0,0c0,0,0,0,0,0 c1.5,0.9,2.9,2,4.1,3.2c2.5,2.3,3.8,5.7,3.7,9.1c-0.3,3.2-2.1,6.1-4.9,7.7c-1.4,0.9-2.8,1.5-4.4,1.9c1.2-0.9,2.1-2.1,2.7-3.5 c0.2-1.6,0-3.3-0.4-4.9c0,0,0,0,0,0c-0.3,1.3-0.8,2.5-1.6,3.6c-0.9,0.9-2,1.5-3.3,1.6c1.2-0.6,2-1.8,2-3.2c-0.1-2-1.7-3.5-3.7-3.5 c-1.9,0-3.4,1.6-3.5,3.5c0,0.5,0.1,1,0.3,1.5c-0.8-0.7-1.3-1.6-1.4-2.6c0,0.1-1.3,5.8,2.4,8.4c1.5,1,3.3,1.4,5.1,1.3 c2.1,0,4.1-0.4,6.1-0.9c0,0,0,0,0,0C26.2,35.5,22.8,36.6,19.3,36.8z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.7c5d46e3492a74acd643b06e567b591b.svg";
export { ForwardRef as ReactComponent };